import { createClient } from '@supabase/supabase-js';

/**
 * Cliente isolado só para validar senha de usuários locais (Supabase Auth).
 * Não persiste sessão: o cliente principal continua como anon, então as políticas RLS
 * existentes valem igual para usuários locais e externos.
 */
const authClient = createClient(
  (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.trim() ?? '',
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined)?.trim() ?? '',
  {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
      detectSessionInUrl: false,
      storageKey: 'local-auth-check',
    },
  }
);

export async function authenticateLocalUser(email: string, password: string): Promise<string | null> {
  const { data, error } = await authClient.auth.signInWithPassword({ email, password });
  if (error || !data.session) return null;
  const token = data.session.access_token;
  await authClient.auth.signOut({ scope: 'local' });
  return token;
}

export async function changeLocalPassword(
  email: string,
  senhaAtual: string,
  novaSenha: string
): Promise<{ success: boolean; message?: string }> {
  const { error: signErr } = await authClient.auth.signInWithPassword({ email, password: senhaAtual });
  if (signErr) return { success: false, message: 'Senha atual incorreta.' };

  const { error } = await authClient.auth.updateUser({ password: novaSenha });
  await authClient.auth.signOut({ scope: 'local' });
  if (error) return { success: false, message: error.message };
  return { success: true };
}
